import { useRiskProfileSocialEconomicRequest } from './useRiskProfileSocialEconomicRequest'
import { useRiskProfileSocialEconomicQuery } from './useRiskProfileSocialEconomicQuery'
import type { PropertiesQueryParams } from '../types/riskProfileProperties.types'

export function useSocialAreaData(queryParams: PropertiesQueryParams | null) {
  const request = useRiskProfileSocialEconomicRequest({
    queryParams,
    widget: 'residentsByArea',
  })
  const query = useRiskProfileSocialEconomicQuery(request)
  return { request, query }
}
